import { create } from 'zustand';

type PlaceItem = {
  account_id: number | string;
  confirmation_status: string;
  description: string;
  id: string | number;
  level: number;
  number: string;
  parking_id: string | number;
  parking_zone_id: number | string | null;
  rates: Rate[];
};

type Rate = {
  daily_intervals: [];
  end: null;
  free_period: number;
  hourly_intervals: [];
  is_active: boolean;
  period: any;
  price: string | number;
  start: null;
  type: string;
};

export const useFreePlacesStore = create<{
  state: PlaceItem[];
  setState: (state: PlaceItem[]) => void;
}>((set) => ({
  state: [] as PlaceItem[],
  setState: (newState: PlaceItem[]) => set({ state: newState }),
}));
